import React from 'react'
import styles from './StatusHandler.module.scss'
import { inject } from 'mobx-react'
import {
  PROJECT_STORE, ProjectStore,
  GENERAL_STORE, GeneralStore
} from 'store'
import { LabeledStatusToggleButton } from 'components'
import { StatusTypes } from 'models'

interface Props {
  project: any;
  [PROJECT_STORE]?: ProjectStore;
  [GENERAL_STORE]?: GeneralStore;
  flatTable?: boolean;
}

const statusOptions = {
  NEW: StatusTypes.NEW,
  NOT_PUBLISHED: StatusTypes.NOT_PUBLISHED,
  PUBLISHED: StatusTypes.PUBLISHED,
  HAS_CHANGES: StatusTypes.HAS_CHANGES
}

const StatusHandler = (props: Props) => {
  const {
    project,
    [PROJECT_STORE]: { changeStatus },
    [GENERAL_STORE]: { confirmAction },
    flatTable
  } = props

  const [loading, setLoading] = React.useState(false)
  React.useEffect(() => setLoading(false), [project.status])

  const statuses = []
  const getStatusesForProject = (prj: any) => {
    if (!prj.children || prj.children.length === 0) {
      statuses.push(prj.status)
      return
    }

    prj.children.forEach(p => getStatusesForProject(p))
  }
  getStatusesForProject(project)

  const handleOnClick = () => {
    const newStatus = project.status === statusOptions.PUBLISHED
      ? statusOptions.NOT_PUBLISHED
      : statusOptions.PUBLISHED

    const title = {
      [statusOptions.NOT_PUBLISHED]: 'Unpublish this project',
      [statusOptions.PUBLISHED]: 'Publish this project'
    }[newStatus]
    const description = {
      [statusOptions.NOT_PUBLISHED]: 'This will unpublish the project and make it disappear from the player. Are you sure?',
      [statusOptions.PUBLISHED]: 'This will publish the project and make it visible in the player. Are you sure?'
    }[newStatus]

    confirmAction({
      title,
      description,
      onSubmit: () => {
        setLoading(true)
        changeStatus(project.id, newStatus)
      }
    })
  }

  const totalNumberOfVideos = statuses.length
  const numberOfPublishedVideos = statuses
    .filter(status => status === statusOptions.PUBLISHED).length

  return (
    <div className={styles.container}>
      {
        project.children
          ? `${totalNumberOfVideos} videos, ${numberOfPublishedVideos} published`
          : (
            <LabeledStatusToggleButton
              status={project.status}
              loading={loading}
              onClick={handleOnClick}
              hideButton={flatTable}
              switchedOn={project.status === statusOptions.PUBLISHED}
            />
          )
      }
    </div>
  )
}

export default inject(PROJECT_STORE, GENERAL_STORE)(StatusHandler)
